import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Switch, Route, withRouter } from 'react-router-dom';

// Components
import Button from 'components/button';
import EmbedControls from 'components/embedControls';
import FlyoutButton from 'components/flyoutButton';
import ShareControls from 'components/shareControls';

// Actions
import { actionToggleFilter, actionResetFilter } from 'actions';

// Helpers
import downloadLink from '../../services/downloadLink';

// Styles
import styles from './tableControls.scss';

const Back = ({
  match: { params: { category, indicatorName } },
  tableFilter = [],
}) => {
  const search = (0 < tableFilter.length) ? `?geos=${tableFilter.join(',')}` : '';
  return (
    <Button
      action={`/${category}/indicator/${indicatorName}/table${search}`}
      label="Back"
      type="transparent"
      icon="back"
      className={styles.back}
    />
  );
};

Back.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      category: PropTypes.string.isRequired,
      indicatorName: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  tableFilter: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const FilterActions = ({
  history,
  pathname,
  toggleFilter,
  resetFilter,
  tableFilterToggle,
}) => (
  <ul className={styles.filterActions}>
    <li>
      <Button
        action={!tableFilterToggle ? toggleFilter : () => {}}
        label="Filter"
        type={tableFilterToggle ? 'active' : 'transparent'}
      />
    </li>
    <li>
      <Button
        action={() => {
          if (tableFilterToggle) {
            toggleFilter();
          }
          resetFilter();
          history.push({ pathname });
        }}
        label="Reset"
        type="transparent"
      />
    </li>
  </ul>
);

FilterActions.propTypes = {
  history: PropTypes.any.isRequired,
  pathname: PropTypes.string.isRequired,
  toggleFilter: PropTypes.func.isRequired,
  resetFilter: PropTypes.func.isRequired,
  tableFilterToggle: PropTypes.bool.isRequired,
};

const TableControls = ({
  dataView,
  history,
  pathname,
  resetFilter,
  slug,
  tableFilter,
  tableFilterToggle,
  title,
  toggleFilter,
}) => (
  <div className={styles.tableControls}>
    <div className={styles.tableActions}>
      <Switch>
        <Route
          path="/:category/indicator/:indicatorName/table/:state/counties"
          render={(props) => (
            <Back {...props} tableFilter={tableFilter} />
          )}
          exact
        />
        <Route
          path="/:category/indicator/:indicatorName"
          render={() => (
            <FilterActions
              toggleFilter={toggleFilter}
              resetFilter={resetFilter}
              tableFilterToggle={tableFilterToggle}
              history={history}
              pathname={pathname}
            />
          )}
        />
      </Switch>
    </div>
    <ul className={styles.downloadActions}>
      <li>
        <Button
          action={downloadLink({
            dataView,
            geos: tableFilter,
            slug,
            type: 'csv',
          })}
          hardLink
          icon="download"
          label="Download Data"
        />
      </li>
      <Route
        path="/:category/indicator/:indicatorName/chart"
        render={() => (
          <li>
            <Button
              action={downloadLink({
                dataView,
                geos: tableFilter,
                primaryView: 'chart',
                slug,
                type: 'image',
              })}
              hardLink
              icon="download"
              label="Download Image"
            />
          </li>
        )}
      />
    </ul>
    <ul className={styles.shareActions}>
      <li>
        <FlyoutButton
          label="Embed"
          type="knockout"
        >
          <EmbedControls
            dataView={dataView}
            geos={tableFilter}
            indicatorView={pathname.substring(`/${dataView}/indicator/${slug}/`.length)}
            slug={slug}
          />
        </FlyoutButton>
      </li>
      <li>
        <FlyoutButton
          label="Share"
          type="knockout"
        >
          <ShareControls
            dataView={dataView}
            geos={tableFilter}
            indicatorView={pathname.substring(`/${dataView}/indicator/${slug}/`.length)}
            slug={slug}
            title={title}
          />
        </FlyoutButton>
      </li>
    </ul>
  </div>
);

TableControls.propTypes = {
  dataView: PropTypes.string.isRequired,
  history: PropTypes.any.isRequired,
  pathname: PropTypes.string.isRequired,
  resetFilter: PropTypes.func.isRequired,
  slug: PropTypes.string.isRequired,
  tableFilter: PropTypes.arrayOf(PropTypes.string).isRequired,
  tableFilterToggle: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  toggleFilter: PropTypes.func.isRequired,
};

const mapStateToProps = ({
  data: {
    indicator: {
      dataView,
      longTitle: title,
      slug,
    },
    tableFilter,
    tableFilterToggle,
  },
}) => ({
  dataView,
  slug,
  tableFilter,
  tableFilterToggle,
  title,
});

const mapDispatchToProps = (dispatch) => ({
  toggleFilter: () => dispatch(actionToggleFilter()),
  resetFilter: () => dispatch(actionResetFilter()),
});

const mergeProps = (
  // Props from state.
  {
    dataView,
    slug,
    tableFilter,
    tableFilterToggle,
    title,
  },

  // Props from dispatch.
  {
    toggleFilter,
    resetFilter,
  },

  // Props from React Router.
  {
    history,
    location: {
      pathname,
    },
  },
) => ({
  dataView,
  history,
  pathname,
  resetFilter,
  slug,
  tableFilter,
  tableFilterToggle,
  title,
  toggleFilter,
});

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(TableControls));



// WEBPACK FOOTER //
// ./app/components/tableControls/index.js